export const SET_RIGHT_SIDEBAR = 'SET_RIGHT_SIDEBAR'
export const SET_LEFT_SIDEBAR = 'SET_LEFT_SIDEBAR'